/**
 * The country a number typed into an in-call invite (client invite panels,
 * Terp's "Add Deaf participant") is read in when it has no "+" or "00":
 *
 * 1. the dial country the person picked on Home (`vrs_dial_country`);
 * 2. the brand's home country (`operations.defaultDialCountry`: MalkaVCS KW);
 * 3. the first country of the account's service region (Gulf KW, US/Canada US);
 * 4. US.
 *
 * Before this a Gulf client who never picked a country had local numbers read
 * as US numbers, and they matched no one.
 */
import { SERVICE_REGIONS } from '../../../shared/service-regions';
import { getWhitelabelConfig } from '../base/whitelabel/functions';
import { currentServiceRegion } from '../mobile/navigation/serviceRegionPreference';
import { getPersistentItem } from '../vrs-auth/storage';
const COUNTRY_CODE = /^[A-Z]{2}$/;
function countryCode(value) {
    return typeof value === 'string' && COUNTRY_CODE.test(value) ? value : null;
}
/**
 * The dial country for an in-call invite, as an ISO 3166 alpha-2 code.
 *
 * @returns {string}
 */
export function inviteDialCountry() {
    const picked = countryCode(getPersistentItem('vrs_dial_country'));
    if (picked) {
        return picked;
    }
    const brand = countryCode(getWhitelabelConfig()?.operations?.defaultDialCountry);
    if (brand) {
        return brand;
    }
    const region = currentServiceRegion();
    return (region && countryCode(SERVICE_REGIONS[region]?.countries[0])) || 'US';
}
